<!-- src/app/app.component.html -->

    <main class="content">
        <router-outlet></router-outlet>
    </main>
